/**
 * flights — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { flights as de_flights } from '../de/flights';

export const flights: Record<keyof typeof de_flights, string> = {
  /* ---------------- the flight list ---------------- */
  'flights.title': 'Flights',
  'flights.new': 'New flight',
  'flights.newTemplate': 'New template',
  'flights.templates': 'Templates',
  'flights.template': 'Template',
  'flights.untitled': 'untitled',
  'flights.noRoute': 'No route',
  'flights.today': 'Today',
  'flights.undated': 'No date',
  'flights.empty.title': 'No flight planned yet.',
  'flights.empty.line': 'A flight starts with two aerodromes on the map.',
  'flights.error': 'The flights cannot be loaded right now.',
  'flights.retry': 'Try again',
  /* the ⋯ menu on a row */
  'flights.menu': 'More actions',
  'flights.open': 'Open',
  'flights.return': 'Create return flight',
  'flights.duplicate': 'Duplicate',
  'flights.saveTemplate': 'Save as template',
  'flights.instantiate': 'Create flight from it',
  'flights.rename': 'Rename',
  'flights.rename.prompt': 'New title',
  'flights.delete': 'Delete',
  'flights.confirm.delete': 'Delete “{title}”?',
};
